import { useQuery } from "@tanstack/react-query";
import { apiGet, ApiError } from "../api/client";

export interface WorkerItem {
  id: number;
  name: string;
  status: "active" | "revoked";
  last_sync_at: string | null;
  last_inspection_at: string | null;
  pin_last_reset_at: string;
  created_at: string;
  revoked_at: string | null;
}

export function useWorkerList(includeRevoked: boolean) {
  return useQuery<WorkerItem[], ApiError>({
    queryKey: ["workers", { includeRevoked }],
    queryFn: () =>
      apiGet<WorkerItem[]>(
        `/api/admin/workers?include_revoked=${includeRevoked ? 1 : 0}`,
      ),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
